module.exports = __webpack_public_path__ + "static/media/arrow.018ba262.svg";